
(function(){
  var box, lista, aggiunto, inCorso=false, daPopup=false;
  function euro(cent){
    try{ return new Intl.NumberFormat('fr-FR',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'}).format(cent/100); }
    catch(e){ return (cent/100).toFixed(2)+' €'; }
  }
  function apri(){ box.classList.add('is-open'); box.setAttribute('aria-hidden','false');
    var w=document.querySelector('.page-wrapper'); if(w) w.style.overflow='hidden'; }
  function chiudi(){ box.classList.remove('is-open'); box.setAttribute('aria-hidden','true');
    var w=document.querySelector('.page-wrapper'); if(w) w.style.overflow=''; }

  function riga(p){
    var v=(p.variants&&p.variants[0])||{};
    var prezzo=euro(p.price);
    var pieno=(p.compare_at_price&&p.compare_at_price>p.price)?'<s>'+euro(p.compare_at_price)+'</s>':'';
    var img=p.featured_image||(p.images&&p.images[0])||'';
    var el=document.createElement('div');
    el.className='hlfup__riga';
    el.innerHTML='<img src="'+img+'&width=200" alt="" loading="lazy">'+
      '<div class="hlfup__info"><p class="hlfup__nome">'+p.title+'</p>'+
      '<span class="hlfup__prezzo">'+prezzo+pieno+'<span class="hlfup__sconto">&minus;5&nbsp;% au panier</span></span></div>'+
      '<button type="button" class="hlfup__add" data-var="'+v.id+'">Ajouter</button>';
    el.querySelector('.hlfup__add').addEventListener('click',function(){
      var b=this; b.disabled=true; b.textContent='...';
      daPopup=true;   // non ridisegnare il pop-up per un'aggiunta fatta da qui
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json'},
        body:JSON.stringify({items:[{id:Number(b.dataset.var),quantity:1}]})})
        .then(function(r){ return r.json(); })
        .then(function(){
          // Etichetta subito: se qualcosa piu' avanti fallisce, il bottone non
          // deve tornare a "Ajouter" e far credere che non sia stato aggiunto.
          b.textContent='\u2713 Ajout\u00e9 \u00b7 \u22125\u00a0%';
          // Lo sconto del 5% vale SOLO passando da qui: applico il codice al
          // volo. Non e' piu' uno sconto automatico di Shopify, quindi un
          // carrello da due articoli composto altrove non lo riceve.
          return fetch('/discount/DUO5',{credentials:'same-origin'}).catch(function(){});
        })
        .then(function(){
          document.dispatchEvent(new CustomEvent('cart:refresh',{bubbles:true}));
        })
        .catch(function(){});
    });
    return el;
  }

  function mostra(prodottoAggiunto, consigliati){
    aggiunto.innerHTML = prodottoAggiunto ?
      '<img src="'+(prodottoAggiunto.image||'')+'" alt=""><b>'+prodottoAggiunto.product_title+'</b>' : '';
    lista.innerHTML='';
    consigliati.slice(0,2).forEach(function(p){ lista.appendChild(riga(p)); });
    var t=document.getElementById('hlfupTitolo'), o=document.getElementById('hlfupOfferta');
    t.style.display = consigliati.length? '' : 'none';
    if(o) o.style.display = consigliati.length? '' : 'none';
    apri();
  }

  // Tipi di prodotto su cui Herbalife non concede sconto al membro:
  // proporli in upsell non porta margine. Vanno esclusi.
  var TIPI_SENZA_MARGINE = ['accessoires','gourdes et bouteilles','mixeurs'];
  var PREZZO_MINIMO = 2000; // centesimi

  function buono(p, giaDentro){
    if(!p || !p.available) return false;
    if(giaDentro[p.id]) return false;
    var t = (p.type || p.product_type || '').toLowerCase().trim();
    if(TIPI_SENZA_MARGINE.indexOf(t) !== -1) return false;
    var prezzo = p.price;
    if(typeof prezzo === 'string') prezzo = Math.round(parseFloat(prezzo)*100); // /products.json da' euro
    return prezzo >= PREZZO_MINIMO;
  }
  function normalizza(p){
    var q = {};
    for(var k in p) q[k] = p[k];
    if(typeof q.price === 'string') q.price = Math.round(parseFloat(q.price)*100);
    if(typeof q.compare_at_price === 'string') q.compare_at_price = q.compare_at_price ? Math.round(parseFloat(q.compare_at_price)*100) : null;
    if(!q.featured_image && q.images && q.images.length) q.featured_image = (typeof q.images[0]==='string')? q.images[0] : q.images[0].src;
    return q;
  }
  function json(u){ return fetch(u,{headers:{'Accept':'application/json'}}).then(function(r){return r.json()}); }

  function dopoAggiunta(variantId){
    if(inCorso) return; inCorso=true;
    json('/cart.js').then(function(cart){
      var it=null;
      for(var i=0;i<cart.items.length;i++){ if(String(cart.items[i].variant_id)===String(variantId)) it=cart.items[i]; }
      if(!it) it=cart.items[cart.items.length-1];
      if(!it){ inCorso=false; return; }
      var giaDentro={}; cart.items.forEach(function(x){ giaDentro[x.product_id]=true; });

      // 1) abbinamenti dichiarati in Shopify, 2) prodotti correlati, 3) le piu' vendute.
      // A ogni passo tengo solo i prodotti ad alto margine.
      return json('/recommendations/products.json?product_id='+it.product_id+'&limit=10&intent=complementary')
        .then(function(d){
          var p=(d.products||[]).map(normalizza).filter(function(x){return buono(x,giaDentro)});
          if(p.length) return p;
          return json('/recommendations/products.json?product_id='+it.product_id+'&limit=10&intent=related')
            .then(function(d2){
              var q=(d2.products||[]).map(normalizza).filter(function(x){return buono(x,giaDentro)});
              if(q.length) return q;
              return json('/collections/meilleures-ventes/products.json?limit=20').then(function(d3){
                return (d3.products||[]).map(function(x){
                  var v=(x.variants&&x.variants[0])||{};
                  return normalizza({id:x.id,title:x.title,handle:x.handle,type:x.product_type,
                    available:v.available!==false, price:v.price,
                    compare_at_price:v.compare_at_price, images:x.images, variants:x.variants});
                }).filter(function(y){return buono(y,giaDentro)});
              });
            });
        })
        .then(function(p){ mostra(it,(p||[]).slice(0,2)); });
    }).catch(function(){}).then(function(){ inCorso=false; });
  }

  // Intercetto le chiamate del tema a /cart/add: funziona con qualunque bottone.
  var fetchOriginale = window.fetch;
  window.fetch = function(){
    var url = arguments[0] && (arguments[0].url || arguments[0]);
    var opz = arguments[1] || {};
    var risposta = fetchOriginale.apply(this, arguments);
    try{
      if(typeof url==='string' && url.indexOf('/cart/add')!==-1){
        var vid=null;
        try{
          var body = opz.body || (arguments[0] && arguments[0].body);
          if(typeof body==='string'){
            try{ vid=(JSON.parse(body).items||[{}])[0].id; }
            catch(e){ vid=new URLSearchParams(body).get('id'); }
          } else if(body && typeof body.get==='function'){ vid=body.get('id'); }
        }catch(e){}
        risposta.then(function(r){
          if(daPopup){ setTimeout(function(){ daPopup=false; },1200); return; }
          if(r&&r.ok) setTimeout(function(){ dopoAggiunta(vid); },450);
        });
      }
    }catch(e){}
    return risposta;
  };

  function avvia(){
    box=document.getElementById('hlfUpsell'); if(!box) return;
    lista=document.getElementById('hlfupLista'); aggiunto=document.getElementById('hlfupAggiunto');
    box.addEventListener('click',function(e){ if(e.target.closest('[data-hlfup-close]')) chiudi(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') chiudi(); });
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',avvia); else avvia();
})();
